var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteAddGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / note-add") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1583333,2.15833333 C11.8416667,1.84166667 11.4166667,1.66666667 10.975,1.66666667 L5,1.66666667 C4.08333333,1.66666667 3.33333333,2.41666667 3.33333333,3.33333333 L3.33333333,16.6666667 C3.33333333,17.5833333 4.075,18.3333333 4.99166667,18.3333333 L15,18.3333333 C15.9166667,18.3333333 16.6666667,17.5833333 16.6666667,16.6666667 L16.6666667,7.35833333 C16.6666667,6.91666667 16.4916667,6.49166667 16.175,6.18333333 L12.1583333,2.15833333 Z M12.5,13.3333333 L10.8333333,13.3333333 L10.8333333,15 C10.8333333,15.4583333 10.4583333,15.8333333 10,15.8333333 C9.54166667,15.8333333 9.16666667,15.4583333 9.16666667,15 L9.16666667,13.3333333 L7.5,13.3333333 C7.04166667,13.3333333 6.66666667,12.9583333 6.66666667,12.5 C6.66666667,12.0416667 7.04166667,11.6666667 7.5,11.6666667 L9.16666667,11.6666667 L9.16666667,10 C9.16666667,9.54166667 9.54166667,9.16666667 10,9.16666667 C10.4583333,9.16666667 10.8333333,9.54166667 10.8333333,10 L10.8333333,11.6666667 L12.5,11.6666667 C12.9583333,11.6666667 13.3333333,12.0416667 13.3333333,12.5 C13.3333333,12.9583333 12.9583333,13.3333333 12.5,13.3333333 Z M10.8333333,6.66666667 L10.8333333,2.91666667 L15.4166667,7.5 L11.6666667,7.5 C11.2083333,7.5 10.8333333,7.125 10.8333333,6.66666667 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar-/-Closed-/-01-Default",
    transform: "translate(-40.000000, -81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.000000, 80.000000)",
    id: "Icon-/-note-add"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#297C78",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteAddGreen);
export default __webpack_public_path__ + "static/media/note-add-green.9b239ffe0f6ff2596aaacedf4c1c0d31.svg";
export { ForwardRef as ReactComponent };